import { render, staticRenderFns } from "./AllRecords.vue?vue&type=template&id=03003548"
import script from "./AllRecords.vue?vue&type=script&lang=js"
export * from "./AllRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports